export default {
  label: "Device Management",
  tabs: {
    devices: {
      label: "Devices",
      deviceList: "Device List",
      noActiveDevicesMessage: "No active devices available",
      activateDevice: {
        label: "Activate Device",
        activateYourDevice: "Activate your device",
        deviceToken: "Device Token",
        enterTokenMessage: "Enter the claiming token shown on your device to link it to your account.",
        singleUseMessage: "The token is single-use and expires after a short time.",
        tokenNotWorkingMessage: "If it doesn’t work, restart your device to generate a new one.",
        afterSubmittingTokenMessage:
          "After submitting the token, your device will be assigned to your account and complete its setup automatically.",
      },
      newDevice: "New Device",
      editDevice: "Edit Device",
      removeButton: "Remove",
      tags: "Tags",
      configuration: "Configuration",
      update: "Update",
      assignments: "Assignments",
      makeAssignment: "Make Assignment",
      unassign: "unassign",
      logs: "logs",
      device: "Device",
      noAsset: "No Asset Assigned",
      noDevice: "No Device Assignment",
      deviceName: "Device Name",
      preRegisteredDevice: {
        title: "Device details cannot be viewed",
        message:
          "This device is not active yet.\n\nYou will be able to view the device details only after it has been activated.",
      },
      noDevicesCreatedYet: "No Devices Created Yet",
      columns: {
        deviceName: "Device Name",
      },
    },
    deleteDevices: {
      label: "Delete Devices",
      message: "Are you sure you want to delete the selected device(s)? This can not be undone.",
      devicesNotDeletedLabel: "Device(s) could not be deleted",
      devicesWithParentMessage: "The following device(s) could not be deleted due to existing parent:",
    },
    deviceGroups: {
      label: "Device Groups",
      list: "Device List",
      activities: "Activities",
      newDeviceGroup: "New Device Group",
    },
    deviceTypes: {
      label: "Device Types",
      labelWithCount: "Device Types ({count})",
      addButton: "Add Model",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Device Type",
      noDeviceTypesCreatedYet: "No Device Types Created Yet",
      contactAdminToCreate: "Please contact your administrator to create device types",
      tabs: {
        models: {
          label: "Models",
          noDeviceModelsCreatedYet: "No Device Models Created Yet",
        },
      },
    },
    sharedModels: {
      label: "Shared Device Models",
      addDeviceModel: "Add Device Model",
      addAndShare: "Add and share",
      noDeviceTypesMessage: "No available device types",
      noDeviceModelsMessage: "No available device models",
      showShareDeviceModelDetails: "Show device model details",
      hideShareDeviceModelDetails: "Hide device model details",
      appsAffectedBySharingMessage: "The following {count} apps will get shared as a result:",
      shareModelWarningMessage:
        "This will share the selected device model with all tenants.\nOnce added, it cannot be removed from this list and will remain available to all tenants.",
      sharedModelsHeaderMessage:
        "Device models listed here are shared with all tenants. Adding a model to this list makes it available across all tenants and marks it as shared in their view.",
      actionPermanentMessage: "This action is permanent and cannot be undone.",
      noDeviceModelsSharedYet: "No device models shared yet",
    },
    deploymentGroups: {
      label: "Deployment Groups",
      newDeploymentGroup: "New Deployment Group",
      updateDeploymentGroup: "Edit Deployment Group",
      sideListTableLabel: "Depl. Groups",
      addButton: "Add Deployment Group",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Deployment Group",
      devices: "Devices",
      iotApps: "Apps",
      Apps: "Apps",
      software: "Software",
      firmware: "Firmware",
      osImage: "OS Image",
      systemApps: "System Apps",
      installedSoftware: "Installed Software",
      noGroupSelected: "No deployment group selected",
      coreApps: "System Apps",
      userName: "User Name",
      email: "Email Address",
      adminLevel: "Admin Level",
      groupInfo: "Group Info",
      actions: "Actions",
      addApp: "Add application",
      removeApp: "Remove application",
      changeImage: "Change Image",
      changeFirmware: "Change Firmware",
      addImage: "Add OS Image",
      addFirmware: "Add Firmware",
      removeImage: "Remove Image",
      removeFirmware: "Remove Firmware",
      removeImageDescription:
        "Removing the OS image from the Deployment Group may affect the functionality of its associated devices. Are you sure you want to proceed?",
      removeFirmwareDescription:
        "Removing the firmware from the Deployment Group may affect the functionality of its associated devices. Are you sure you want to proceed?",
      developer: "Developer",
      developerNote: "Developer's Note",
      deployedDevicesCount: "{deployedDeviceCount} devices out of {totalDeviceCount}",
      publisher: "Publisher",
      addDevices: "Add Devices",
      noCoreAppsInDeploymentGroup: "No core apps have been added to this deployment group yet.",

      noAppsInDeploymentGroup: "No apps have been added to this deployment group yet.",
      noDevicesInDeploymentGroup: "No devices have been added to this deployment group yet.",
      activeDeploymentGroup: "Active deployment group",
      addDevicesEmptyMessage:
        "Select devices from the list on the right and click the left arrow to add them to this deployment group.",
      addDevicesNoneAvailableMessage: "No available devices with this model.",
      addDevicesDescription:
        "Use the transfer list to add devices to your group. The available devices are already filtered by type and model to match the requirements of your active deployment group.",
      deleteFleetTitle: "Delete Fleet",
      deleteDescription1:
        "Are you sure you want to delete this deployment group? Deleting it will result in the loss of its app setup",
      deleteDescription2:
        "You cannot delete a deployment group with assigned devices. Please remove or relocate the devices to another deployment group before attempting deletion.",
      removeAppTitle: "Remove App",
      removeAppDescription:
        "Removing the app from the Deployment Group will uninstall it from associated devices, potentially affecting their functionality. Are you sure you want to proceed?",
      created: "Created",
      edited: "Edited",
      deploymentStatus: "Deployment Status",
      changeVersion: {
        cancel: "Cancel",
        deploy: "Deploy",
      },
      selectDevicesMessage:
        "Select devices from the list on the right and click the left arrow to add them to this deployment group.",
      successCreatedMessage: "Deployment group created successfully",
      successUpdatedMessage: "Deployment group updated successfully",
      noDeploymentGroupsCreatedYet: "No Deployment Groups Created Yet",
      addAppModal: {
        modalSteps: {
          chooseApp: "Choose App",
          chooseImage: "Choose Image",
          chooseFirmware: "Choose Firmware",
          selectVersion: "Select Version",
          deploy: "Deploy",
        },
        appAndRevisionFields: {
          firstReleaseDate: "First Released Date",
          firstReleaseBy: "First Released By",
          versions: "Versions",
          currentlyInstalledOn: "Currently Installed On",
        },
        noAppDetailsMessage: "No App Details are Available",
        newDeploymentTitle: "New deployment for {deploymentGroupName}",
        confirmDeployMessage:
          "I am aware that this action may affect the functionality of the devices in selected deployment group.",
      },
      addOrRemoveDevices: {
        addDevices: "Add Devices",
        availableDevices: "Available Devices",
        addDevicesDescription:
          "Use the transfer list to add devices to your group. The available devices are already filtered by type and model to match the requirements of your active deployment group.",
        selectDevicesMessage:
          "Select devices from the list on the right and click the left arrow to add them to this deployment group.",
        confirmDevicesChangesMessage: `Changes to deployment group devices have been made. Apps will be removed or installed to these devices
                to reflect the configuration of their new deployment group. These adjustments may have implications for
                device functionality and their associated use cases. Do you want to save anyway?`,
      },
    },
    attributeFieldsAndSets: {
      label: "Attribute Fields and Sets",
      addButton: "Add Attribute",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Attribute",
    },
    deploymentGroupAdmins: {
      label: "Deployment Group Admins",
      transferRights: "Transfer Rights",
      admin: "Admin",
      confirmAdminChange: "Confirm Change",
      coAdmin: "Co-Admin",
      addCoAdminButton: "Add Co-Admin",
      adminChangeModalTitle: "Change deployment group admin",
      removeCoAdminModalTitle: "Remove co-admin",
      emailTextField: "Email Address",
      tryAgainButton: "Try again",
      errorGeneral: "Something went wrong",
      errorEmailTitle: "Email adress not found",
      removeCoAdminModalText: "Are you sure you want to remove this co-admin from this deployment group?",
      adminChangeModalText:
        "By designating a new admin, you will lose the ability to manage this deployment group and will retain only viewer permissions.",
      errorMessageEmail: "Please enter a valid email address of a person from your organization.",
      textMessageUpdateAdmin:
        "By designating a new admin, you will lose the ability to manage this deployment group and will retain only viewer permissions.",
      textAddCoAdmin:
        "Please provide the email address of the individual from your organization to whom you wish to grant permission to manage this deployment group. Note that this person will not have the ability to change admin settings.",
      errorMessageAddCoAdmin: "The specified user is already a co-administrator for the specified deployment group.",
      addCoAdminModalTitle: "Add co-admin",
      addCoAdminText: "New co-admin",
      addCoAdminEmailTextField: "Email Address",
    },
    groups: {
      label: "Groups",
      addButton: "Add Deployment Group",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Deployment Group",
    },
    types: {
      label: "Types",
      addButton: "Add Deployment Groups",
      editModel: "Edit",
      deleteModel: "Delete",
      newDeviceType: "New Deployment Groups",
    },
    deviceDetails: {
      label: "Device Details",
      currentFleet: "Current Deployment Group",
      deviceNameHeader: "Device Name",
      deviceName: "Name",
      deviceType: "Type",
      deviceModel: "Model",
      deviceRevision: "Revision",
      hardwareSerialNumber: "Hardware Serial No.",
      deviceSerial: "Software Serial No.",
      storeActivity: "Last Store Activity",
      messagingActivity: "Last Messaging Activity",
      lastUptime: "Last Uptime",
      bytesSent: "bytes sent",
      installationHistory: {
        buttonLabel: "Installation history",
        title: "Installation history of {serialNumber}",
        columns: {
          dateTime: "Date & Time",
          appName: "App name",
          category: "Category",
          action: "Action",
          originalVersion: "Original version",
          targetVersion: "Target version",
          size: "Size [MB]",
        },
        categories: {
          Image: "OS Image",
          App: "App",
          Firmware: "Firmware",
        },
        changeTypes: {
          Install: "New installation",
          Upgrade: "Upgrade",
          Downgrade: "Downgrade",
          Uninstall: "Deinstallation",
          Unknown: "Unknown",
        },
      },
      logs: {
        timestamp: "Timestamp",
        logLevel: "Log Level",
        signalName: "Signal Name",
        message: "Message",
        timeRange: "Time Range",
        last1Hour: "Last 1 hour",
        last6Hours: "Last 6 hours",
        last24Hours: "Last 24 hours",
        last7Days: "Last 7 days",
      },
    },
    editDevice: {
      deviceCannotBeEdited: {
        title: "Device cannot be edited",
        messageLineOne: "This device is not active yet.",
        messageLineTwo: "You will be able to edit the device details only after it has been activated.",
        okButton: "OK",
        cancelButton: "CANCEL",
      },
      noDeviceFound: {
        title: "No Device Found",
        messageWithAssetId: "No device found for asset ID:",
        messageNoAssetId: "No asset ID provided",
        loadingMessage: "Loading device...",
        goBackButton: "Go Back",
      },
    },
  },
};
